module.exports = __webpack_public_path__ + "static/img/iphone_msptitle4.9f7dfc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle4.png
// module id = Cb6V
// module chunks = 0